const component = require('./component.js')

document.querySelector('body').appendChild(component({ heading: 'Testing 1 2 3' }))
